import * as React from "react";
import { ChangeEvent, MouseEvent } from "react";

import { DebtorType } from "types";

import MonthlyPlanField from "./MonthlyPlanField";
import PaycheckAmountField from "./PaycheckAmountField";
import ScheduleTypeField from "./ScheduleTypeField";
import { ClientErrorsType } from "./types";

interface PropsType {
  debtor: DebtorType;
  errors: ClientErrorsType;
  feeDisplayEnabled: boolean;
  form: {
    onMonthlyPaymentChange(e: ChangeEvent<HTMLInputElement>): void;
    onPaycheckAmountChange(e: ChangeEvent<HTMLInputElement>): void;
    onScheduleChange(e: ChangeEvent<HTMLInputElement>): void;
    roundUp(e: MouseEvent): void;
  };
  monthlyPayment: string;
  paycheckAmount: string;
  roundingEnabled: boolean;
  selectedSchedule: string;
}

const EditPaymentSchedule = (props: { visible: boolean }): JSX.Element => {
  const { visible } = props;

  if (!visible) return null;

  return (
    <div className="form--actions">
      <a
        className="button button--blue"
        href="/employer/settings#payment-schedule"
      >
        <i className="fas fa-calendar-alt" />
        <span>Edit Payment Schedule</span>
      </a>
    </div>
  );
};

export default function EditScheduleFieldset(props: PropsType): JSX.Element {
  const {
    debtor,
    errors,
    feeDisplayEnabled,
    form,
    monthlyPayment,
    paycheckAmount,
    roundingEnabled,
    selectedSchedule,
  } = props;

  return (
    <section>
      <div className="form--fieldset payment-schedule">
        <div className="content">
          <header>
            <div className="badge">
              <i className="fas fa-dollar-sign" />
            </div>

            <h2>Payment Schedule</h2>
          </header>

          <div className="form--description">
            <h3>
              What Does the <em>Paycheck Schedule</em> Mean?
            </h3>

            <p>
              Depending on the employer, payroll will follow one of several
              schedules. By choosing the schedule, TFS can correctly calculate
              the amount needed from each paycheck.
            </p>
          </div>

          <div className="body">
            <ScheduleTypeField
              onScheduleChange={form.onScheduleChange}
              readOnly={debtor.wagePull}
              value={selectedSchedule}
              {...{ errors }}
            />

            <EditPaymentSchedule visible={debtor.wagePull} />

            <MonthlyPlanField
              error={errors.monthlyPayment}
              onChange={form.onMonthlyPaymentChange}
              value={monthlyPayment}
            />

            <PaycheckAmountField
              error={errors.paycheckAmount}
              onChange={form.onPaycheckAmountChange}
              onRoundUp={form.roundUp}
              value={paycheckAmount}
              {...{ feeDisplayEnabled, roundingEnabled }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
